import kzPbReader from "./kz/pbreader.json";
import ruApparatPolicy from "./ru/apparatPolicy.json";
import kzApparatPolicy from "./kz/apparatPolicy.json";
import enApparatPolicy from "./en/apparatPolicy.json";
import enPbReader from "./en/pbreader.json";
import ruPbReader from "./ru/pbreader.json";
import ruService from "./ru/service.json";
import enService from "./en/service.json";
import kzService from "./kz/service.json";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import Russian translations
import ruHeader from "./ru/header.json";
import ruRouteList from "./ru/routeList.json";
import ruPaymentPage from "./ru/paymentPage.json";
import ruFooter from "./ru/footer.json";
import ruPrinting from "./ru/printing.json";
import ruPrices from "./ru/prices.json";
import ruAdvertisement from "./ru/advertisement.json";
import ruTopUsers from "./ru/topUsers.json";
import ruVerifyUser from "./ru/verifyUser.json";
import ruListDoc from "./ru/listDoc.json";
import ruDocItems from "./ru/docItems.json";
import ruEditDoc from "./ru/editDoc.json";
import ruLanguage from "./ru/language.json";
import ruInactivityModal from "./ru/inactivityModal.json";
import rufileView from "./ru/fileView.json";
import ruEditManyDocs from "./ru/editManyDocs.json";

// Import English translations
import enHeader from "./en/header.json";
import enRouteList from "./en/routeList.json";
import enPaymentPage from "./en/paymentPage.json";
import enFooter from "./en/footer.json";
import enPrinting from "./en/printing.json";
import enPrices from "./en/prices.json";
import enAdvertisement from "./en/advertisement.json";
import enTopUsers from "./en/topUsers.json";
import enVerifyUser from "./en/verifyUser.json";
import enListDoc from "./en/listDoc.json";
import enDocItems from "./en/docItems.json";
import enEditDoc from "./en/editDoc.json";
import enLanguage from "./en/language.json";
import enInactivityModal from "./en/inactivityModal.json";
import enfileView from "./en/fileView.json";
import enEditManyDocs from "./en/editManyDocs.json";

// Import Kazakh translations
import kzHeader from "./kz/header.json";
import kzRouteList from "./kz/routeList.json";
import kzPaymentPage from "./kz/paymentPage.json";
import kzFooter from "./kz/footer.json";
import kzPrinting from "./kz/printing.json";
import kzPrices from "./kz/prices.json";
import kzAdvertisement from "./kz/advertisement.json";
import kzTopUsers from "./kz/topUsers.json";
import kzVerifyUser from "./kz/verifyUser.json";
import kzListDoc from "./kz/listDoc.json";
import kzDocItems from "./kz/docItems.json";
import kzEditDoc from "./kz/editDoc.json";
import kzLanguage from "./kz/language.json";
import kzInactivityModal from "./kz/inactivityModal.json";
import kzfileView from "./kz/fileView.json";
import kzEditManyDocs from "./kz/editManyDocs.json";

const resources = {
    ru: {
        translation: {
            apparatPolicy: ruApparatPolicy,
            pbreader: ruPbReader,
            service: ruService,
            header: ruHeader,
            routeList: ruRouteList,
            paymentPage: ruPaymentPage,
            footer: ruFooter,
            printing: ruPrinting,
            prices: ruPrices,
            advertisement: ruAdvertisement,
            top_users: ruTopUsers,
            verifyUser: ruVerifyUser,
            listDoc: ruListDoc,
            docItems: ruDocItems,
            editDoc: ruEditDoc,
            language: ruLanguage,
            inactivityModal: ruInactivityModal,
            fileView: rufileView,
            editManyDocs: ruEditManyDocs,
        },
    },
    en: {
        translation: {
            apparatPolicy: enApparatPolicy,
            pbreader: enPbReader,
            service: enService,
            header: enHeader,
            routeList: enRouteList,
            paymentPage: enPaymentPage,
            footer: enFooter,
            printing: enPrinting,
            prices: enPrices,
            advertisement: enAdvertisement,
            top_users: enTopUsers,
            verifyUser: enVerifyUser,
            listDoc: enListDoc,
            docItems: enDocItems,
            editDoc: enEditDoc,
            language: enLanguage,
            inactivityModal: enInactivityModal,
            fileView: enfileView,
            editManyDocs: enEditManyDocs,
        },
    },
    kk: {
        translation: {
            apparatPolicy: kzApparatPolicy,
            pbreader: kzPbReader,
            service: kzService,
            header: kzHeader,
            routeList: kzRouteList,
            paymentPage: kzPaymentPage,
            footer: kzFooter,
            printing: kzPrinting,
            prices: kzPrices,
            advertisement: kzAdvertisement,
            top_users: kzTopUsers,
            verifyUser: kzVerifyUser,
            listDoc: kzListDoc,
            docItems: kzDocItems,
            editDoc: kzEditDoc,
            language: kzLanguage,
            inactivityModal: kzInactivityModal,
            fileView: kzfileView,
            editManyDocs: kzEditManyDocs,
        },
    },
};

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        // lng не задаём явно: если задать, i18next-browser-languagedetector
        // полностью отключается (см. его доки), и после любой полной перезагрузки
        // страницы (например, "refresh-page" от Electron) язык всегда сбрасывался
        // бы на захардкоженное значение, а не на тот, что реально выбрал
        // пользователь. fallbackLng — то, что покажется только при первом запуске,
        // пока в localStorage ещё нет i18nextLng.
        fallbackLng: "kk",
        detection: {
            // Без "navigator": на большинстве машин/киосков системная локаль — "ru",
            // и он почти всегда "успешно" определяется раньше, чем сработает
            // fallbackLng, из-за чего казахский по умолчанию никогда не показывался.
            // Теперь единственный источник — то, что пользователь реально выбрал
            // сам (сохраняется в localStorage при changeLanguage); если выбора ещё
            // не было, используется fallbackLng ("kk").
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        interpolation: {
            escapeValue: false,
        },
        debug: process.env.NODE_ENV === "development",
    });

export default i18next;
